/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateBindingTokenRequest } from '../models/CreateBindingTokenRequest';
import type { SuccessResponse_ActiveTokenResponse_ } from '../models/SuccessResponse_ActiveTokenResponse_';
import type { SuccessResponse_BindingTokenResponse_ } from '../models/SuccessResponse_BindingTokenResponse_';
import type { SuccessResponse_TokenPreviewResponse_ } from '../models/SuccessResponse_TokenPreviewResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BindingTokensService {
    /**
     * Create Token Endpoint
     * POST /api/v1/binding-tokens — 生成/复用绑定 token (D6 yes §0.5 #4).
     * @returns SuccessResponse_BindingTokenResponse_ Successful Response
     * @throws ApiError
     */
    public static createTokenEndpointApiV1BindingTokensPost({
        requestBody,
    }: {
        requestBody: CreateBindingTokenRequest,
    }): CancelablePromise<SuccessResponse_BindingTokenResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/binding-tokens',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Preview Token Endpoint
     * GET /api/v1/binding-tokens/{token}/preview — 公开, 无 JWT.
     * @returns SuccessResponse_TokenPreviewResponse_ Successful Response
     * @throws ApiError
     */
    public static previewTokenEndpointApiV1BindingTokensTokenPreviewGet({
        token,
    }: {
        token: string,
    }): CancelablePromise<SuccessResponse_TokenPreviewResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/binding-tokens/{token}/preview',
            path: {
                'token': token,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Wxacode Endpoint
     * GET /api/v1/binding-tokens/{token}/wxacode — 公开小程序码图片.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static wxacodeEndpointApiV1BindingTokensTokenWxacodeGet({
        token,
    }: {
        token: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/binding-tokens/{token}/wxacode',
            path: {
                'token': token,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Wxacode Data Endpoint
     * GET /api/v1/binding-tokens/{token}/wxacode-data — 小程序码 base64.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static wxacodeDataEndpointApiV1BindingTokensTokenWxacodeDataGet({
        token,
    }: {
        token: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/binding-tokens/{token}/wxacode-data',
            path: {
                'token': token,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Active Token Endpoint
     * GET /api/v1/stores/{store_id}/employees/{employee_id}/active-token.
     * @returns SuccessResponse_ActiveTokenResponse_ Successful Response
     * @throws ApiError
     */
    public static getActiveTokenEndpointApiV1StoresStoreIdEmployeesEmployeeIdActiveTokenGet({
        storeId,
        employeeId,
    }: {
        storeId: number,
        employeeId: number,
    }): CancelablePromise<SuccessResponse_ActiveTokenResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/employees/{employee_id}/active-token',
            path: {
                'store_id': storeId,
                'employee_id': employeeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
